module.exports = __webpack_public_path__ + "static/media/dr018.eea10ded.jpg";